// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cbp-dialog-background{position:fixed;top:0;left:0;z-index:50;display:none;overflow:hidden;align-items:flex-start;width:100%;height:100%;background-color:rgba(34,34,34,.75);pointer-events:none;transition:.2s opacity}.cbp-dialog-background--show{display:flex;pointer-events:all}.cbp-dialog .modal-header{text-align:left}.cbp-dialog .modal-body{text-align:left}", ""]);
// Exports
module.exports = exports;
